import React, { PropsWithChildren } from 'react';
import { BoxProps as GrommetBoxProps, CardBody as GrommetCardBody } from 'grommet';
import { Box, BoxProps } from '/src/components';

export const CardBody: React.FC<CardBodyProps> = ({ children, ...props }) => {
  const {
    gap = '1rem',
    saveButton,
    pad = '1.5rem',
    saveButtonPad = '1.5rem',
    width = '33%',
    innerBoxProps,
    ...boxProps
  } = props;

  return (
    <GrommetCardBody gap="none" {...boxProps}>
      <Box elevation="small" pad={pad} gap={gap} {...innerBoxProps}>
        {children}
      </Box>
      {!!saveButton && (
        <Box pad={saveButtonPad} width={width}>
          {saveButton}
        </Box>
      )}
    </GrommetCardBody>
  );
};

export type CardBodyProps = PropsWithChildren &
  GrommetBoxProps & {
    saveButton?: React.ReactNode;
    saveButtonPad?: GrommetBoxProps['pad'];
    innerBoxProps?: BoxProps;
  };
